(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kk-sportfluid-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-kk-bundle-form]');
    if (!form) return;
    event.preventDefault();
    const offer = form.closest('[data-kk-sportfluid-offer]');
    const button = form.querySelector('button[type="submit"]');
    const status = offer.querySelector('[data-kk-bundle-status]');
    const defaultText = button.dataset.defaultText;
    button.disabled = true;
    button.textContent = offer.dataset.loadingText;
    status.textContent = '';
    try {
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('cart');
      window.location.assign(form.dataset.cartUrl || `${root}cart`);
    } catch (error) {
      status.textContent = offer.dataset.errorText;
      button.disabled = false;
      button.textContent = defaultText;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
